import { CheckCircle2 } from "lucide-react";
import { useSearchParams } from "react-router";
import SigneringResultCard, {
  SigneringResultActionLink,
} from "@cle/components/signering/SigneringResultCard";
import {
  getSigneringMessage,
  getSigneringSearchParams,
  isAfgorelseIndberetningSignering,
} from "@cle/utils/signeringSearchParams";
import { eftPath } from "@cle/constants/routes";

const SigneringDoneView = () => {
  const [searchParams] = useSearchParams();
  const { messageId, signeringstype, signingUser } =
    getSigneringSearchParams(searchParams);
  const message = getSigneringMessage(messageId);
  const isAfgorelseSignering = isAfgorelseIndberetningSignering(signeringstype);

  const backLinkTo = isAfgorelseSignering
    ? eftPath("afgorelser")
    : eftPath("indberetninger");

  const backLinkLabel = isAfgorelseSignering
    ? "Tilbage til afgørelser"
    : "Tilbage til forsiden";

  return (
    <div className="cle-signering-result-page">
      <SigneringResultCard
        variant="success"
        icon={<CheckCircle2 size={36} strokeWidth={1.75} aria-hidden />}
        title={`Godkendt ${signingUser ? "af " + signingUser : "dig"}`}
        description={"Din indberetning er godkendt."}
        messageHtml={message || undefined}
        actions={
          <SigneringResultActionLink
            id="cle-signering-done-back"
            to={backLinkTo}
          >
            {backLinkLabel}
          </SigneringResultActionLink>
        }
      />
    </div>
  );
};

export default SigneringDoneView;
